"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PaginationPhoenix = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _Dropdown = _interopRequireDefault(require("../baseComponents/Dropdown"));
var _index = require("../../index");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//TODO test to update and validate story
var PaginationPhoenix = exports.PaginationPhoenix = function PaginationPhoenix(props) {
  //perPage props
  var values = props.values;

  //Set dropdown values
  var perPageValues = values.map(function (el, index) {
    return {
      "value": "".concat(el),
      "label": ["".concat(el, " "), props.perPageText],
      "selected": el == props.limit
    };
  });

  //pagination props validations
  var totalPages = Math.ceil(props.currentCount / props.limit);
  if (totalPages === 0) totalPages = 1;
  var page = Math.round(props.offset / props.limit + 1);
  if (page > totalPages) page = totalPages;
  var nextPageDisabled = page === totalPages;
  var previousPageDisabled = page === 1;

  //React state hook
  var _useState = (0, _react.useState)(page),
    _useState2 = _slicedToArray(_useState, 2),
    userPage = _useState2[0],
    setUserPage = _useState2[1];
  //On change of value of page or props.limit, set userInput value to the calculated page
  (0, _react.useEffect)(function () {
    setUserPage(page);
  }, [page, props.limit]);

  //Component validation on returned value based on props.
  var onUserInputChange = function onUserInputChange(event) {
    // Validate user input
    // value - 1 because  offset starts at 0 not 1
    if (isNaN(event.target.value)) return;
    var value = parseInt(event.target.value) - 1;
    if (value < 0) value = 0;
    if (value > totalPages - 1) value = totalPages - 1;
    props.onChange(event, props.limit, value * props.limit, "input");
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pagination-component phoenix"
  }, /*#__PURE__*/_react["default"].createElement(_index.Row, null, /*#__PURE__*/_react["default"].createElement(_index.Col, {
    xs: 6,
    className: "perPage-section"
  }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    options: perPageValues,
    closeOnMouseOut: true,
    type: "custom",
    onChange: function onChange(event, input, option) {
      props.onChange(event, parseInt(option.value), 0, "dropdown");
    }
  })), /*#__PURE__*/_react["default"].createElement(_index.Col, {
    xs: 6,
    className: "pagination-section"
  }, totalPages === 1 ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "onePage"
  }, totalPages) : /*#__PURE__*/_react["default"].createElement("input", {
    onFocus: function onFocus(e) {
      e.target.select();
    },
    "data-test": "input",
    type: "text",
    onKeyDown: function onKeyDown(event) {
      if (event.keyCode === 13) {
        onUserInputChange(event);
      }
    },
    value: userPage,
    onChange: function onChange(event) {
      return setUserPage(event.target.value);
    }
  }), props.ofText, " ", totalPages, /*#__PURE__*/_react["default"].createElement("button", {
    className: "previousButton",
    disabled: previousPageDisabled,
    onClick: function onClick(event) {
      // page - 2 because we go down 1 and offset starts at 0, so another -1
      props.onChange(event, props.limit, (page - 2) * props.limit, "arrowDown");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head",
    className: "previous"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    disabled: nextPageDisabled,
    "data-test": "next",
    className: "next",
    onClick: function onClick(event) {
      props.onChange(event, props.limit, page * props.limit, "arrowUp");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head"
  })))));
};
PaginationPhoenix.propTypes = {
  perPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  values: _propTypes["default"].arrayOf(_propTypes["default"].number),
  ofText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  onChange: _propTypes["default"].func,
  limit: _propTypes["default"].number,
  offset: _propTypes["default"].number,
  currentCount: _propTypes["default"].number
};
PaginationPhoenix.defaultProps = {
  perPageText: "perPage",
  values: [25, 50, 100],
  ofText: "of",
  limit: 25,
  offset: 1,
  currentCount: 1,
  onChange: function onChange() {}
};
var _default = exports["default"] = PaginationPhoenix;